export function warehouseValidate(warehouse){
    var result = true;

    result = validateId(warehouse.id);
    result = validateName(warehouse.name);    
    result = validateCountry(warehouse.country);
    result = validateState(warehouse.state);
    result = validateZipcode(warehouse.zipcode);
    result = validateMunicipality(warehouse.municipality);
    result = validateNeighborhood(warehouse.neighborhood);
    result = validateStreet(warehouse.street);
    result = validateExternalNumber(warehouse.external_number);
    result = validateInternalNumber(warehouse.internal_number);
    result = validatePickingRequired(warehouse.picking_required);

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateName(name){
    if(typeof customer === 'string' && name.trim() !== '') return true;
    else return false;
}

function validateCountry(country){
    if(typeof country === 'string' && country.trim() !== '') return true;
    else return false;
}

function validateState(state){
    if(typeof state === 'string' || state.trim() !== '') return true;
    else return false;
}

function validateZipcode(zipcode){
    if(typeof zipcode === 'string' || zipcode.trim() !== '') return true;
    else return false;
}

function validateMunicipality(municipality) {
    if(typeof municipality === 'string' || municipality.trim() !== '') return true;
    else return false;
}

function validateNeighborhood(neighborhood) {
    if(typeof neighborhood === 'string' || neighborhood.trim() !== '') return true;
    else return false;
}

function validateStreet(street) {
    if(typeof street === 'string' || street.trim() !== '') return true;
    else return false;
}

function validateExternalNumber(external_number) {
    if(typeof external_number === 'string' || external_number.trim() !== '') return true;
    else return false;
}

function validateInternalNumber(internal_number) {
    if(typeof internal_number === 'string' || internal_number.trim() !== '') return true;
    else return false;
}

function validatePickingRequired(picking_required) {
    if(typeof picking_required === 'boolean' && picking_required.trim() !== null) return true;
    else return false;
}

// function validateWarehouse(warehouse){
//     if(!Number.isInteger(warehouse.id)) return false;
//     if(typeof warehouse.name !== 'string' || warehouse.name.trim() === '') return false;
//     if(typeof warehouse.picking_required !== 'boolean') return false;

//     return true;
// }